import React from 'react/addons';
import cx from 'classnames';


var Options = React.createClass({
  propTypes: {
    children: React.PropTypes.array.isRequired,
    onMouseDown: React.PropTypes.func.isRequired
  },

  getDefaultProps() {
    return {
      onMouseDown: function() {},
    };
  },

  getInitialState() {
    return {
      orientation: 'below'
    };
  },

  checkPosition() {
    // measure height and offset
    var $options = this.getDOMNode();
    var height = $options.offsetHeight;
    var viewportHeight = window.innerHeight;

    var $parent = $options.offsetParent;
    var {bottom} = $parent.getBoundingClientRect();

    if (height + bottom > viewportHeight) {
      // set top to be above input
      height += 2;
      this.setState({
        orientation: 'above',
        topOffset: height * -1
      });
    } else {
      this.setState({
        orientation: 'below',
        topOffset: null
      });
    }
  },

  /**
  * I think it hijacks fastclick and enables default browser behavior. 
  * It may be bug with fastclick that I'd like Jon or Andy to take a 
  * look at. KNOWN ISSUE: Using Chrome's Android
  * emulator, the user will have to tap 2x to make a selection.
  * Tested it on Luis's Android and it worked fine.
  **/

  handleTouch(event) {
    event.stopPropagation();
  },

  handleMouseDown() {
    this.props.onMouseDown(event);
  },

  componentDidMount() {
    this.checkPosition();

    this.events = ['resize', 'scroll', 'touchmove'];

    this.events.forEach((event) => {
      window.addEventListener(event, this.checkPosition);
    });

    // see comment block above
    this.getDOMNode().addEventListener('touchstart', this.handleTouch);
  },

  componentWillUnmount() {
    this.events.forEach((event) => {
      window.removeEventListener(event, this.checkPosition);
    });
    // see comment block above
    this.getDOMNode().addEventListener('touchstart', this.handleTouch);
  },

  render() {
    var {orientation, topOffset} = this.state;

    var optionClasses = {
      'ofs-List': true,
      'ofs-SimpleChoice__Options': true,
      'ofs-SimpleChoice__Options--is-above': orientation === 'above',
      'ofs-SimpleChoice__Options--is-below': orientation === 'below',
    };

    var style = {
      'top': topOffset
    };

    return (
      <ul className={cx(optionClasses)} style={style}
        onMouseDown={this.handleMouseDown} ref="options">
        {this.props.children}
      </ul>
    );
  }
});

export default Options;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/simple-choice/Options.jsx
 **/